export enum BidderStatus {
    Approved,
    Denied,
}
